import { levelImpulse } from '@constant'

export const getMyLevel = (pulses = 0, configuredLevels) => {
  const levels = normalizeLevels(configuredLevels)
  const level =
    levels.find(
      ({ min, max }) => pulses >= min && (max ? pulses < max : true),
    ) ?? {}

  return {
    pulses,
    lvl: level.lvl,
    name: level.name,
    percent: level.max
      ? Math.floor(((pulses - level.min) * 100) / (level.max - level.min))
      : 100,
    progress: level.max ? pulses - level.min : pulses,
    required: level.max ? level.max - level.min : 0,
    next: level.max ? level.max - pulses : 0,
  }
}

const normalizeLevels = (configuredLevels) => {
  if (!Array.isArray(configuredLevels) || configuredLevels.length === 0) {
    return levelImpulse
  }

  const sorted = configuredLevels
    .map((level, index) => ({
      lvl: index + 1,
      name: level.name || `${index + 1} уровень`,
      min: Number(level.pulses) || 0,
    }))
    .sort((left, right) => left.min - right.min)

  return sorted.map((level, index) => ({
    ...level,
    max: sorted[index + 1]?.min,
  }))
}
